import React, { useContext, useEffect, useState } from 'react'
import './users.css'
import AppConext from '../../Context/AppContext'
import AccessTimeFilled from '@mui/icons-material/AccessTimeFilled'
import DoDisturbOn from '@mui/icons-material/DoDisturbOn'
import VerifiedUser from '@mui/icons-material/VerifiedUser'
import PendingInvites from '../../component/SigupRequestsTables/PendingInvites'
import ApprovedUsers from '../../component/SigupRequestsTables/ApprovedUsers'
import RevokedUsers from '../../component/SigupRequestsTables/RevokedUsers'
import UnauthorizedAccess from '../../component/unAuthorizedAccess/UnauthorizedAccess'
import { useParams } from 'react-router-dom';
import GetUserList from '../../Apis/GetUSerList'

const Users = () => {

    const { openDrawer } = useContext(AppConext)
    const userDetails = JSON.parse(localStorage.getItem('user'))
    const { requestType } = useParams()
    const [isDataLoading, setIsDataLoading] = useState(true)
    // const [dataValues, setDataValues] = useState([])
    const [rows, setRows] = useState([])

    const getUserData = async () => {
        setIsDataLoading(true);
        try {
            const requestTypeData = requestType === 'pending-requests' ? 'pending' : requestType === 'approved-users' ? 'approved' : requestType === 'declined-users' ? 'revoked' : null
            const response = await GetUserList(requestTypeData);
            setRows(response.data.data);
        } catch (error) {
            console.log('Error fetching data:', error);
        }
        setIsDataLoading(false);
    };

    useEffect(() => {
        getUserData()
    }, [requestType])



    return (<>
        {userDetails?.accountConfig?.permissions?.approveRequest === false ?
            <UnauthorizedAccess />
            :
            <div className={openDrawer ? 'mainContainer_SignupRequests drawerOpen_signUpRequest' : 'mainContainer_SignupRequests'}>
                <div className={openDrawer ? 'mainDiv_SignupRequests drawer drawerOpen_maindivSR' : 'mainDiv_SignupRequests drawerClose_maindivSR'}>
                    <div className='titleContainer'>
                        {requestType === 'pending-requests' ?
                            <>
                                <AccessTimeFilled className='iconTitle_signupRequest' />
                                <span>Pending Requests</span>
                            </>
                            : requestType === 'approved-users' ?
                                <>
                                    <VerifiedUser className='iconTitle_signupRequest' />
                                    <span>Approved Users</span>
                                </>
                                : requestType === 'declined-users' ?
                                    <>
                                        <DoDisturbOn className='iconTitle_signupRequest' />
                                        <span>Declined Users</span>
                                    </>
                                    : null
                        }

                    </div>

                    {
                        requestType === 'pending-requests' ?
                            <PendingInvites
                                rows={rows}
                                isDataLoading={isDataLoading}
                                setIsDataLoading={setIsDataLoading}
                                setRows={setRows}
                            />
                            : requestType === 'approved-users' ?
                                <ApprovedUsers
                                    rows={rows}
                                    isDataLoading={isDataLoading}
                                    setIsDataLoading={setIsDataLoading}
                                    setRows={setRows}
                                />
                                : requestType === 'declined-users' ?
                                    <RevokedUsers
                                        rows={rows}
                                        isDataLoading={isDataLoading}
                                        setIsDataLoading={setIsDataLoading}
                                        setRows={setRows}
                                     />
                                    : null
                    }

                </div>
            </div>
        }
    </>
    )
}

export default Users